interface OpenChatData {
    /**
     * 聊天对象的nick，含站点名称，例如cntaobaoXXX（淘宝），chalichnYYY（中文站）等等
     */
    nick: string;
    bizDomain: "taobao" | "cbu";
    securityUID: string;
    text?: string;
    sceneParam: '{"toRole":"buyer"}' | '{"toRole":"seller"}';
}

/**
 * 千牛打开用户聊天窗口
 *
 * @see https://open.taobao.com/doc.htm?docId=120962&docType=1
 */
export function qnOpenChat(data: OpenChatData) {
    // @ts-ignore
    return my.qn.openChat(data);
}
